var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "use-detail-dialog",
      attrs: {
        visible: _vm.visible,
        width: "1100px",
        "close-on-click-modal": false,
        "show-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c(
            "div",
            { staticClass: "title-main" },
            [
              _c("span", { staticClass: "title-text" }, [_vm._v("使用详情")]),
              _vm._v(" "),
              _c("el-tag", { attrs: { size: "mini", type: "success" } }, [
                _vm._v(
                  "使用渠道：" + _vm._s(_vm.detailData.channelTypeDesc || "-")
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title-meta" }, [
            _c("span", [
              _vm._v("创建：" + _vm._s(_vm.detailData.createTime || "-")),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("最后更新：" + _vm._s(_vm.detailData.updateTime || "-")),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("卡密批次：" + _vm._s(_vm.detailData.batchNo || "-")),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "info-section" }, [
        _c("div", { staticClass: "info-grid" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("卡密ID")]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.detailData.instanceCardId || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("SKU ID")]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.detailData.skuId || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("商品名称")]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.detailData.productName || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("卡号")]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.detailData.cardNo || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("卡密")]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.detailData.cardSecret || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("有效期")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "info-value" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.detailData.validityDesc || "-") +
                    "\n          "
                ),
                _vm.detailData.remainingDays != null
                  ? _c(
                      "el-tag",
                      {
                        staticClass: "ml-6",
                        attrs: {
                          type: "warning",
                          size: "mini",
                          effect: "plain",
                        },
                      },
                      [
                        _vm._v(
                          "\n            剩余 " +
                            _vm._s(_vm.detailData.remainingDays) +
                            " 天\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item info-item-wide" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("备注")]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value" }, [
              _vm._v(_vm._s(_vm.detailData.remark || "-")),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("卡状态")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "info-value" },
              [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.cardStatusTagType(_vm.detailData.cardStatus),
                      size: "mini",
                    },
                  },
                  [_vm._v(_vm._s(_vm.detailData.cardStatusDesc || "-"))]
                ),
                _vm._v(" "),
                _vm.detailData.activatedAt
                  ? _c("span", { staticClass: "muted ml-6" }, [
                      _vm._v("激活于 " + _vm._s(_vm.detailData.activatedAt)),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("关联小程序")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "info-value" },
              [
                _vm.detailData.customerName
                  ? _c("el-tag", { attrs: { size: "mini", effect: "plain" } }, [
                      _vm._v(_vm._s(_vm.detailData.customerName)),
                    ])
                  : _c("span", [_vm._v("-")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item info-item-wide" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v("关联用户ID")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "info-value user-line" },
              [
                _c("span", { staticClass: "user-id" }, [
                  _vm._v(_vm._s(_vm.detailData.userId || "-")),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "muted" }, [
                  _vm._v("手机：" + _vm._s(_vm.detailData.phone || "-")),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "muted" }, [
                  _vm._v("姓名：" + _vm._s(_vm.detailData.userName || "-")),
                ]),
                _vm._v(" "),
                _vm.detailData.realNameAuthenticated
                  ? _c(
                      "el-tag",
                      {
                        attrs: { type: "info", size: "mini", effect: "plain" },
                      },
                      [_vm._v("已实名")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item info-item-wide" }, [
            _c("span", { staticClass: "info-label" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c("span", { staticClass: "info-value user-line" }, [
              _c("span", { staticClass: "muted" }, [
                _vm._v(
                  "身份证号：" + _vm._s(_vm.detailData.identityCardNo || "-")
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "muted" }, [
                _vm._v("昵称：" + _vm._s(_vm.detailData.nickname || "-")),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "record-section" },
        [
          _c("div", { staticClass: "record-title" }, [
            _c("span", { staticClass: "title-main" }, [_vm._v("使用记录")]),
            _vm._v(" "),
            _c("span", { staticClass: "title-sub" }, [
              _vm._v("一卡通预约核销明细"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-cards" }, [
            _c("div", { staticClass: "stat-card" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.stat.total)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [_vm._v("总商品")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "stat-card" }, [
              _c("div", { staticClass: "stat-value" }, [
                _c("span", { staticClass: "stat-green" }, [
                  _vm._v(_vm._s(_vm.stat.used)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "stat-sep" }, [_vm._v("/")]),
                _vm._v(" "),
                _c("span", { staticClass: "stat-muted" }, [
                  _vm._v(_vm._s(_vm.stat.waiting)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v("已使用 / 待使用"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.recordLoading,
                  expression: "recordLoading",
                },
              ],
              staticClass: "record-table",
              attrs: {
                data: _vm.recordList,
                border: "",
                size: "small",
                "row-key": "rightConfigId",
              },
              on: { "expand-change": _vm.handleExpandChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "div",
                          { staticClass: "expand-wrap" },
                          [
                            _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: props.row.detailLoading,
                                    expression: "props.row.detailLoading",
                                  },
                                ],
                                staticClass: "expand-table",
                                attrs: {
                                  data: props.row.detailList,
                                  "max-height": 360,
                                  size: "mini",
                                  border: "",
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "idx",
                                    label: "序号",
                                    width: "60",
                                    align: "center",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "orderNo",
                                    label: "订单号",
                                    "min-width": "190",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(scope.row.orderNo || "-")
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "payTime",
                                    label: "支付时间",
                                    "min-width": "160",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(scope.row.payTime || "-")
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "reservationTime",
                                    label: "预约时间",
                                    "min-width": "160",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.reservationTime || "-"
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "useCount",
                                    label: "使用次数",
                                    width: "90",
                                    align: "center",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "useTime",
                                    label: "使用时间",
                                    "min-width": "160",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(scope.row.useTime || "-")
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "使用状态",
                                    "min-width": "120",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                class: scope.row.useTime
                                                  ? "status-used"
                                                  : "status-waiting",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      scope.row.useStatusDesc ||
                                                        "-"
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            props.row.detailTotal > 0
                              ? _c(
                                  "div",
                                  { staticClass: "expand-pagination" },
                                  [
                                    _c("el-pagination", {
                                      attrs: {
                                        "current-page": props.row.detailPage,
                                        "page-size": props.row.detailLimit,
                                        layout: "total, prev, pager, next",
                                        total: props.row.detailTotal,
                                        small: "",
                                        background: "",
                                      },
                                      on: {
                                        "current-change": function ($event) {
                                          return _vm.handleDetailCurrentChange(
                                            props.row,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "spuName",
                  label: "商品信息",
                  "min-width": "240",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "product-cell" }, [
                          _c("div", { staticClass: "product-name" }, [
                            _vm._v(_vm._s(scope.row.spuName || "-")),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "product-sku" }, [
                            _vm._v(
                              "SPU ID：" +
                                _vm._s(scope.row.relatedProductId || "-")
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "spuCode",
                  label: "商品编码",
                  "min-width": "160",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "权益次数",
                  "min-width": "110",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.unlimitedFlag === 1
                              ? "不限次"
                              : scope.row.useCount || 0
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "已使用 / 待使用",
                  "min-width": "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "stat-green" }, [
                          _vm._v(_vm._s(scope.row.usedCount)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-sep" }, [
                          _vm._v(" / "),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-muted" }, [
                          _vm._v(_vm._s(scope.row.waitingCount)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "record-pagination" },
            [
              _c("span", { staticClass: "pagination-info" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.recordTotal
                        ? (_vm.recordPage - 1) * _vm.recordLimit + 1
                        : 0
                    ) +
                    " - " +
                    _vm._s(
                      Math.min(
                        _vm.recordPage * _vm.recordLimit,
                        _vm.recordTotal
                      )
                    ) +
                    " / 共 " +
                    _vm._s(_vm.recordTotal) +
                    " 条\n      "
                ),
              ]),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.recordPage,
                  "page-sizes": [8],
                  "page-size": _vm.recordLimit,
                  layout: "prev, pager, next",
                  total: _vm.recordTotal,
                  small: "",
                  background: "",
                },
                on: { "current-change": _vm.handleRecordCurrentChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关 闭")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }